import { Divider, Stack, Typography } from '@mui/material';
import { ReactComponent as BriefcaseCheckIcon } from '../../../../../../assets/icons/layout-icons/BriefcaseCheckIcon.svg';
import CustomModal from '../../../../../../components/modal/CustomModal';
import { secondaryBlue } from '../../../../../../utils/color';
import CustomButton from '../../../../../../components/button/CustomButton';
import LinkedInLoginButton from '../../../../../../components/button/LinkedInLoginButton';

export interface ReviewModalProps {
  open: boolean;
  handleConfirm: () => void;
  handleCancel: () => void;
  isLoading?: boolean;
  handleLinkedIn: () => void;
}

const ReviewModal = ({
  open,
  handleConfirm,
  handleCancel,
  isLoading,
  handleLinkedIn,
}: ReviewModalProps) => (
  <CustomModal open={open} sx={{ width: '100%', maxWidth: '600px' }}>
    <Stack spacing={2}>
      <Stack direction="row" alignItems="center">
        <Stack
          width={40}
          height={40}
          mr={2}
          bgcolor="secondaryBlue.100"
          borderRadius={1}
          justifyContent="center"
          alignItems="center"
        >
          <BriefcaseCheckIcon width="20px" fill={secondaryBlue[700]} height="20px" />
        </Stack>
        <Typography variant="heading5">Verify your identity </Typography>
        {/* <Typography variant="heading5">schedule call</Typography> */}
      </Stack>
      <Divider />
      <Stack spacing={6} pb={2}>
        <Typography pt={1} pb={1} variant="body3" color="primaryDark.500">
          Thank you for submitting your case study review. The last step is to schedule a quick call
          with a Spona advisor or log in with LinkedIn so that we can verify your identity and
          publish your review on our platform.
        </Typography>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          sx={{ justifyContent: 'center', alignItems: 'center' }}
          spacing={2}
        >
          <CustomButton sx={{ width: 'fit-content' }} loading={isLoading} onClick={handleConfirm}>
            Schedule a call
          </CustomButton>
          <Divider orientation="vertical" flexItem>
            {' '}
            <Typography sx={{ pb: '4px' }}>or</Typography>{' '}
          </Divider>

          <LinkedInLoginButton loading={isLoading} onClick={handleLinkedIn}>
            Login with LinkedIn
          </LinkedInLoginButton>
        </Stack>
      </Stack>
      <Divider />
      <Stack direction="row" sx={{ justifyContent: 'right' }} spacing={2}>
        <CustomButton loading={isLoading} variant="primaryLight" onClick={handleCancel}>
          Cancel
        </CustomButton>
      </Stack>
    </Stack>
  </CustomModal>
);

export default ReviewModal;
